import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
	{
		path: '/',
		name: 'home-root',
		components: {
			default: () => import('./HomeRootView.vue'),
		},
	},
]
